// @flow
import config from '../../config';
import { buildQueryParams } from './search-optimizations-request';
import { createApiCall } from './api-factory';

const BASE_URL = config.CARRIER_OPTIMIZATION_ANALYTICS_URL;

const makeApiCall = createApiCall(BASE_URL, buildQueryParams);

const getOptimizedCarriers = (query) => makeApiCall('/optimized_carriers', query);

const getOptimizedTransitTimeByDayServiceLevel = (query) =>
    makeApiCall('/optimized_transit_time_by_service_level', query);

const getOptimizedTotalCost = (query) => makeApiCall('/optimized_total_cost', query);

const getOptimizedAvgCost = (query) => makeApiCall('/optimized_average_cost', query);

const getOptimizedAggregatedCostByService = (query) =>
    makeApiCall('/optimized_aggregated_cost_by_service', query);

const getOptimizedShipFromLocations = (query) => makeApiCall('/optimized_ship_from_locations', query);

export {
    getOptimizedCarriers,
    getOptimizedTransitTimeByDayServiceLevel,
    getOptimizedTotalCost,
    getOptimizedAvgCost,
    getOptimizedAggregatedCostByService,
    getOptimizedShipFromLocations,
};
